import { createSelector } from '@ngrx/store';

import * as fromDocumentUpload from '../../reducers/document-upload/document-upload.reducer';
import * as fromFeature from '../../reducers/index';

export const selectDocumentUploadState = createSelector(
  fromFeature.getDocumentUploadState,
  (state) => state,
);
export const selectFilesMetadata = createSelector(fromFeature.getDocumentUploadState, (state) => {
  return state.filesMetaData;
});
export const selectClearData = createSelector(fromFeature.getDocumentUploadState, (state) => {
  return state.clearData;
});
export const selectIsDocumentInState = createSelector(
  selectDocumentUploadState,
  fromDocumentUpload.getHasClientUploadedFile,
);
